import OverlayTrigger from '@rio-cloud/rio-uikit/components/overlay/OverlayTrigger';
import { datetimeFormatter, formatMeasuredValue } from '../../../shared/utils';
import { valueStringFormat } from '../../../shared/utils/formatters';
import { ColumnLabel } from '../models/ColumnLabel';
import { IInfractionResult } from '../models/InfractionResult';
import Tooltip from '@rio-cloud/rio-uikit/components/tooltip/Tooltip';

type TableRowContentProps = {
  row: any;
  index: number;
  columns: string[];
  columnLabels: ColumnLabel;
  expandedRows: string[];
  handleToggleRow: (id: string) => void;
  subRows: string[],
  infractionName: string
};

const MISSING_VALUE = '---';

const TableRowContent = (props: TableRowContentProps) => {
  const { row, index, columns, columnLabels, expandedRows, handleToggleRow, subRows, infractionName } = props;
  const isExpanded = expandedRows.includes(`${index}`);

  return (
    <tr className='compactRow'>
      {columns.map(col => {
        if (subRows.includes(col)) return null;

        if (col === 'extraAction' && row.items.length > 0) {
          return (
            <td
              key={col}
              className='table-action'
              onClick={() => {
                handleToggleRow(`${index}`);
              }}
            >
              <span>
                <span className='btn btn-muted btn-icon-only'>
                  <span className={`rioglyph ${isExpanded ? 'rioglyph-chevron-up' : 'rioglyph-chevron-down'}`} />
                </span>
              </span>
            </td>
          );
        }

        if (col === 'tripStart' || col === 'tripFinal') {
          return (
            <td key={col} className='text-size-14' data-field={columnLabels[col]}>
              <span>{datetimeFormatter.format(new Date(row[col as keyof IInfractionResult]))}</span>
            </td>
          );
        }

        if (col === 'occurrences') {
          return (
            <td data-field={columnLabels[col]} >
              <OverlayTrigger
                key={crypto.randomUUID()}
                overlay={
                  <Tooltip id='tooltip' allowOnTouch>
                    {row[col as keyof IInfractionResult]} {row[col as keyof IInfractionResult] == 1 ? ' Evento' : ' Eventos'}
                  </Tooltip>
                }
              >
                <div style={{ minWidth: 90, textTransform: 'capitalize' }} className={row[col as keyof IInfractionResult] == 0 ? 'label label-success' : 'label label-warning'}>
                  {valueStringFormat(row[col as keyof IInfractionResult])}
                  {row[col as keyof IInfractionResult] == 1 ? ' Evento' : ' Eventos'}
                </div>
              </OverlayTrigger>
              <OverlayTrigger
                key={crypto.randomUUID()}
                overlay={
                  <Tooltip id='tooltip' allowOnTouch>
                    Evento(s) por Quilômetro
                  </Tooltip>
                }
              >
                <div className='label label-default margin-left-5'>{row['eventPerKilometer']} EPK</div>
              </OverlayTrigger>
            </td>
          )
        }

        if (col === 'cumKilometers') {
          return (
            <td className='text-size-14' data-field={columnLabels[col]}>
              <span>
                {Number.parseFloat(row[col]) >= 0 ? row[col as keyof IInfractionResult] : MISSING_VALUE} Km
              </span>
            </td>
          )
        }

        if (col === 'measuredValue' || col === 'configKilometers') {
          return (
            <td className='text-size-14' data-field={columnLabels[col]}>
              <span>
                {formatMeasuredValue(row[col as keyof IInfractionResult], infractionName)}
              </span>
            </td>
          )
        }

        if (col === 'engineHours') {
          return (
            <td className='text-size-14' data-field={columnLabels[col]}>
              <span>
                {row[col as keyof IInfractionResult]}
              </span>
            </td>
          )
        }

        return (
          <td className='text-size-14' data-field={columnLabels[col]}>
            <span>
              {formatMeasuredValue(row[col as keyof IInfractionResult], infractionName)}
            </span>
          </td>
        )
      })}
    </tr>
  );
};

export default TableRowContent;